module.exports = __webpack_public_path__ + "img/swiper_03.7f13f0f6.jpg";